@if (preview()) {
    <div
        class="flex items-center justify-between px-10 py-4 border-2 rounded-md"
        [ngClass]="hasError() ? 'border-red-500' : 'border-gray-900/10'"
    >
        <div class="text-lg font-semibold text-gray-800 whitespace-nowrap">
            {{ title() }}
        </div>
        <div
            class="ml-6 flex-1 text-md text-gray-900 truncate"
            [ngClass]="isBlank() ? 'text-gray-400 italic' : ''"
            [title]="value()"
        >
            {{ isBlank() ? "-" : value() }}
        </div>
    </div>
} @else {
    <div
        class="flex flex-col px-10 py-4 border-2 border-gray-900/10 rounded-md"
        [ngClass]="hasError() ? 'border-red-500' : 'border-gray-900/10'"
    >
        <div class="text-lg font-semibold my-1">{{ title() }}</div>
        <div class="w-1/3">
            <input
                class="w-full h-10 border focus:outline-none rounded-md text-md p-2"
                type="text"
                [placeholder]="placeholder()"
                [disabled]="disabled()"
                [ngModel]="value()"
                (ngModelChange)="onValueChange($event)"
            />
        </div>
    </div>
}
